module.exports = __webpack_public_path__ + "static/media/afm-warning-2x-nl.f041d371.jpg";